import axios from 'axios';
import { authHeader } from './utils';
import { GET_NOTICE_MACRO, LIST_NOTICE_MACRO } from './types';

export const getNoticeMacro = (id) => async (dispatch) => {
  const res = await axios.get(`/api/notices/macros/${id}`, {
    headers: authHeader(),
  });
  console.log('res', res.data);
  dispatch({ type: GET_NOTICE_MACRO, payload: res.data });
};

export const fetchNoticeMacros = (page, limit) => async (dispatch) => {
  const res = await axios.get('/api/notices/macros', {
    headers: authHeader(),
    params: { page, limit },
  });
  console.log('res', res.data);
  dispatch({ type: LIST_NOTICE_MACRO, payload: res.data });
};

export const submitNoticeMacro =
  ({ noticeMacro }, navigate) =>
  async (dispatch) => {
    const res = await axios.post('/api/notices/macros', noticeMacro, {
      headers: authHeader(),
    });
    navigate('/notices/macros');
  };

export const updateNoticeMacro =
  ({ noticeMacro, id }, navigate) =>
  async (dispatch) => {
    const res = await axios.put(`/api/notices/macros/${id}`, noticeMacro, {
      headers: authHeader(),
    });
    navigate('/notices/macros');
  };

export const deleteNoticeMacro =
  ({ id }, navigate) =>
  async (dispatch) => {
    try {
      const res = await axios.delete(`/api/notices/macros/${id}`, {
        headers: authHeader(),
      });
      navigate('/notices/macros');
    } catch (error) {
      console.log(error);
    }
  };
